export default function Hero() {
  return (
    <section
      id="hero"
      className="relative min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden bg-background-50"
    >
      <div className="absolute inset-0 z-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20abstract%20digital%20illustration%20with%20warm%20coral%20orange%20and%20soft%20peach%20gradient%20tones%2C%20flowing%20geometric%20shapes%20representing%20social%20media%20content%20and%20digital%20entertainment%2C%20modern%20minimalist%20composition%20with%20circular%20and%20curved%20elements%2C%20soft%20diffused%20lighting%2C%20editorial%20quality%2C%20clean%20aesthetic%2C%20no%20text&width=1800&height=900&seq=hero-bg-51chigua&orientation=landscape"
          alt="51今日吃瓜 - 全网热门吃瓜短视频"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/25 to-black/45"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-6xl mx-auto flex flex-col lg:flex-row items-center gap-10 lg:gap-16">
          <div className="flex-1 w-full text-center lg:text-left">
            <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-primary-500/20 border border-primary-400/30 mb-6">
              <span className="w-2 h-2 rounded-full bg-primary-500 animate-pulse"></span>
              <span className="text-sm font-medium text-primary-200 whitespace-nowrap">实时更新 · 全网热门</span>
            </div>

            <h1 className="text-3xl md:text-4xl lg:text-5xl font-heading text-white leading-tight mb-4">
              51今日吃瓜
              <br />
              <span className="text-primary-200">全网热门吃瓜短视频与直播回放合集</span>
            </h1>

            <p className="text-lg md:text-xl text-white/80 font-light mb-3">
              吃瓜不停，精彩不断
            </p>

            <p className="text-sm md:text-base text-white/65 leading-relaxed max-w-xl lg:max-w-none mb-8">
              51今日吃瓜网汇集全网最新最热的吃瓜短视频、直播回放与吃瓜大赛精选内容，覆盖娱乐圈动态、网红八卦、社会热点事件，每日实时更新海量视频合集。无论你是资深瓜友还是偶尔吃瓜的路人，这里都有最新鲜、最劲爆的瓜等你来品。
            </p>

            <div className="flex flex-wrap items-center justify-center lg:justify-start gap-6 mb-8">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">10万+</div>
                <div className="text-xs text-white/55 mt-1">海量视频资源</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">每日更新</div>
                <div className="text-xs text-white/55 mt-1">热点实时追踪</div>
              </div>
              <div className="w-px h-10 bg-white/15"></div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-heading text-accent-300">全平台覆盖</div>
                <div className="text-xs text-white/55 mt-1">多端同步观看</div>
              </div>
            </div>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-3">
              <a
                href="#media"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#media')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-primary-500 hover:bg-primary-600 text-white font-bold rounded-full transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-play-circle-line text-xl"></i>
                立即吃瓜
              </a>
              <a
                href="#ranking"
                onClick={(e) => {
                  e.preventDefault();
                  document.querySelector('#ranking')?.scrollIntoView({ behavior: 'smooth' });
                }}
                className="inline-flex items-center gap-2 px-8 py-3.5 bg-white/10 hover:bg-white/20 text-white border border-white/25 font-medium rounded-full transition-all duration-200 text-base whitespace-nowrap cursor-pointer"
              >
                <i className="ri-fire-line text-xl"></i>
                热门榜单
              </a>
            </div>
          </div>

          <div className="flex-1 w-full max-w-md lg:max-w-none">
            <div className="relative rounded-2xl overflow-hidden aspect-[4/5] lg:aspect-[3/4] bg-background-900/30 backdrop-blur-sm border border-white/10">
              <img
                src="https://readdy.ai/api/search-image?query=Stylized%20digital%20art%20of%20a%20modern%20smartphone%20screen%20displaying%20vibrant%20social%20media%20content%20feed%20with%20entertainment%20news%20and%20viral%20video%20thumbnails%2C%20warm%20orange%20and%20coral%20color%20palette%2C%20contemporary%20flat%20design%20aesthetic%2C%20soft%20ambient%20glow%2C%20clean%20composition%2C%20editorial%20quality%2C%20minimal%20and%20modern&width=900&height=1200&seq=hero-visual-51chigua&orientation=portrait"
                alt="51今日吃瓜手机端展示"
                className="w-full h-full object-cover"
              />
              <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/60 to-transparent p-6">
                <div className="flex items-center gap-2">
                  <span className="w-3 h-3 rounded-full bg-primary-500"></span>
                  <span className="text-white/80 text-sm">随时随地 吃瓜不停</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}